import React from 'react';
import { hero, WHATSAPP_URL } from '../../content/siteContent';
import HeroBelt from './HeroBelt';
import { ArrowRightIcon, ChevronsDownIcon, HexagonIcon } from './Icons';

export default function Hero() {
  return (
    <section id="inicio" className="hero">
      {/* Âncoras usadas pela versão anterior do site */}
      <span id="Hero" className="anchor-alias" aria-hidden="true" />
      <span id="hero" className="anchor-alias" aria-hidden="true" />

      <div className="hero-glow" />
      <HeroBelt />

      <div className="hero-content">
        <div className="hero-badge">
          <HexagonIcon />
          {hero.badge}
        </div>
        <h1 className="hero-title">
          {hero.titleStart} <span>{hero.titleHighlight}</span>
        </h1>
        <p className="hero-subtitle">{hero.subtitle}</p>
        <div className="hero-actions">
          <a href="#solucoes" className="btn-outline">
            {hero.secondaryButton}
            <ChevronsDownIcon />
          </a>
          <a id="SaibaMais" href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="btn-gold">
            {hero.primaryButton}
            <ArrowRightIcon />
          </a>
        </div>
      </div>
    </section>
  );
}
